<template>
  <div id="sistemas-externos">
    <Menu />

    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Sistemas externos"
            description="Configure as chaves de assinatura utilizadas nas integrações com sistemas externos."
            url="/administracao"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-5711"
            pageIdentifier="sistemas-externos"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-warning chaves-alerta">
            <i class="icofont-warning-alt"></i>

            <div>
              <strong>Atenção</strong>

              <p class="mb-0">
                Após salvar uma chave de assinatura, ela não poderá ser
                visualizada novamente. Caso seja necessário, você poderá
                substituí-la informando uma nova chave.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="loading-container">
        <b-spinner label="Carregando"></b-spinner>
      </div>

      <div v-else class="row">
        <div
          v-for="integracao in integracoes"
          :key="integracao.tipo"
          class="col-md-6 mb-4"
        >
          <div class="integracao-card">
            <div class="integracao-card__header">
              <div>
                <h3>{{ integracao.nome }}</h3>

                <p>
                  {{ integracao.descricao }}
                </p>
              </div>

              <span
                class="integracao-status"
                :class="{
                  'integracao-status--configurada': integracao.configurada,
                  'integracao-status--pendente': !integracao.configurada,
                }"
              >
                {{
                  integracao.configurada
                    ? 'Chave configurada'
                    : 'Não configurada'
                }}
              </span>
            </div>

            <div class="integracao-informacoes">
              <div v-if="!possuiParceiro" class="integracao-informacoes__item">
                <span class="integracao-informacoes__label">
                  Nome do sistema
                </span>

                <div class="integracao-informacoes__valor">
                  <span>
                    {{
                      integracao.tipo === 'saude_responde'
                        ? 'Saúde Responde'
                        : 'eSUS Feedback'
                    }}
                  </span>

                  <button
                    type="button"
                    class="btn btn-dark btn-sm integracao-informacoes__copiar"
                    @click="
                      copiarInformacao(
                        integracao.tipo === 'saude_responde'
                          ? 'Saúde Responde'
                          : 'eSUS Feedback',
                        'Nome do sistema'
                      )
                    "
                  >
                    <i class="icofont-copy"></i>
                  </button>
                </div>
              </div>

              <div class="integracao-informacoes__item">
                <span class="integracao-informacoes__label">
                  Local de acesso
                </span>

                <span class="integracao-informacoes__valor">
                  {{
                    integracao.tipo === 'saude_responde'
                      ? 'Selecione Atendimento'
                      : 'Selecione Menu Lateral'
                  }}
                </span>
              </div>

              <div class="integracao-informacoes__item">
                <span class="integracao-informacoes__label">
                  Adicionar restrições
                </span>

                <span class="integracao-informacoes__valor">
                  Selecione o município desejado
                </span>
              </div>

              <div class="integracao-informacoes__item">
                <span class="integracao-informacoes__label"> URL </span>

                <div class="integracao-informacoes__valor">
                  <span class="integracao-informacoes__texto">
                    {{ obterUrlIntegracao(integracao) }}
                  </span>

                  <button
                    type="button"
                    class="btn btn-dark btn-sm integracao-informacoes__copiar"
                    :disabled="!uuid"
                    @click="copiarUrl(integracao)"
                  >
                    <i class="icofont-copy"></i>
                  </button>
                </div>
              </div>

              <div v-if="!possuiParceiro" class="integracao-informacoes__item">
                <span class="integracao-informacoes__label"> Responsável </span>

                <div class="integracao-informacoes__valor">
                  <span>eSUS Feedback</span>

                  <button
                    type="button"
                    class="btn btn-dark btn-sm integracao-informacoes__copiar"
                    @click="copiarInformacao('eSUS Feedback', 'Responsável')"
                  >
                    <i class="icofont-copy"></i>
                  </button>
                </div>
              </div>

              <div v-if="!possuiParceiro" class="integracao-informacoes__item">
                <span class="integracao-informacoes__label"> CNPJ </span>

                <div class="integracao-informacoes__valor">
                  <span>45.180.436/0001-48</span>

                  <button
                    type="button"
                    class="btn btn-dark btn-sm integracao-informacoes__copiar"
                    @click="copiarInformacao('45.180.436/0001-48', 'CNPJ')"
                  >
                    <i class="icofont-copy"></i>
                  </button>
                </div>
              </div>

              <div v-if="!possuiParceiro" class="integracao-informacoes__item">
                <span class="integracao-informacoes__label"> E-mail </span>

                <div class="integracao-informacoes__valor">
                  <span>suporte@esusfeedback.com.br</span>

                  <button
                    type="button"
                    class="btn btn-dark btn-sm integracao-informacoes__copiar"
                    @click="
                      copiarInformacao('suporte@esusfeedback.com.br', 'E-mail')
                    "
                  >
                    <i class="icofont-copy"></i>
                  </button>
                </div>
              </div>
            </div>

            <template v-if="uuid">
              <div
                v-if="integracao.configurada && !integracao.editando"
                class="chave-configurada"
              >
                <div class="chave-configurada__status">
                  <div class="chave-configurada__conteudo">
                    <i class="icofont-lock"></i>

                    <div>
                      <strong>
                        {{
                          integracao.tipo === 'saude_responde'
                            ? 'Atendimento'
                            : 'Menu lateral'
                        }}
                      </strong>

                      <p class="mb-0">
                        A chave de assinatura já foi cadastrada e não pode ser
                        visualizada.
                      </p>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="btn btn-outline-primary"
                    @click="iniciarAlteracao(integracao)"
                  >
                    <i class="icofont-refresh"></i>
                    Alterar chave
                  </button>
                </div>
              </div>

              <form v-else @submit.prevent="confirmarSalvamento(integracao)">
                <div class="form-group">
                  <label :for="`chave-${integracao.tipo}`">
                    {{
                      integracao.configurada
                        ? 'Nova chave de assinatura'
                        : 'Chave de assinatura'
                    }}
                  </label>

                  <div class="input-group">
                    <input
                      :id="`chave-${integracao.tipo}`"
                      v-model.trim="integracao.novaChave"
                      :type="integracao.exibirChave ? 'text' : 'password'"
                      class="form-control"
                      autocomplete="new-password"
                      placeholder="Informe a chave de assinatura gerada no sistema externo"
                      :disabled="integracao.salvando"
                    />

                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        :title="
                          integracao.exibirChave
                            ? 'Ocultar chave'
                            : 'Exibir chave'
                        "
                        :disabled="integracao.salvando"
                        @click="
                          integracao.exibirChave = !integracao.exibirChave
                        "
                      >
                        <i
                          :class="
                            integracao.exibirChave
                              ? 'icofont-eye-blocked'
                              : 'icofont-eye'
                          "
                        ></i>
                      </button>
                    </div>
                  </div>

                  <small class="form-text text-muted">
                    Confira a chave de assinatura antes de salvar. Depois do
                    salvamento, ela não estará mais disponível para
                    visualização.
                  </small>
                </div>

                <div class="integracao-card__acoes">
                  <button
                    v-if="integracao.configurada"
                    type="button"
                    class="btn btn-outline-secondary"
                    :disabled="integracao.salvando"
                    @click="cancelarAlteracao(integracao)"
                  >
                    Cancelar
                  </button>

                  <button
                    type="submit"
                    class="btn btn-primary"
                    :disabled="!integracao.novaChave || integracao.salvando"
                  >
                    <b-spinner
                      v-if="integracao.salvando"
                      small
                      class="mr-1"
                    ></b-spinner>

                    {{
                      integracao.configurada
                        ? 'Salvar nova chave'
                        : 'Salvar chave'
                    }}
                  </button>
                </div>
              </form>
            </template>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-confirmar-chave"
      ref="modalConfirmarChave"
      title="Confirmar chave de assinatura"
      @hidden="limparModalConfirmacao"
    >
      <template v-if="integracaoSelecionada">
        <div
          v-if="integracaoSelecionada.configurada"
          class="alert alert-warning mb-3"
        >
          <i class="icofont-warning-alt"></i>

          Você está alterando a chave de assinatura atualmente cadastrada. Essa
          alteração inativará a integração atual, sendo necessário realizar uma
          nova integração. É realmente isso que deseja?
        </div>

        <div v-else class="alert alert-warning mb-3">
          <i class="icofont-warning-alt"></i>

          Depois de salvar, esta chave de assinatura não poderá ser visualizada
          novamente.
        </div>

        <p class="mb-3">
          Deseja
          {{ integracaoSelecionada.configurada ? 'substituir' : 'cadastrar' }}
          a chave de assinatura de
          <strong>{{ integracaoSelecionada.nome }}</strong
          >?
        </p>

        <div
          v-if="integracaoSelecionada.configurada"
          class="custom-control custom-checkbox"
        >
          <input
            id="confirmar-alteracao-chave"
            v-model="alteracaoConfirmada"
            type="checkbox"
            class="custom-control-input"
            :disabled="salvandoModal"
          />

          <label class="custom-control-label" for="confirmar-alteracao-chave">
            Estou ciente de que a integração atual será inativada e precisará
            ser configurada novamente.
          </label>
        </div>
      </template>

      <template #modal-footer>
        <button
          type="button"
          class="btn btn-secondary"
          :disabled="salvandoModal"
          @click="$refs.modalConfirmarChave.hide()"
        >
          Cancelar
        </button>

        <button
          type="button"
          class="btn btn-primary"
          :disabled="!podeConfirmarSalvamento"
          @click="salvarChave"
        >
          <b-spinner v-if="salvandoModal" small class="mr-1" />

          Confirmar e salvar
        </button>
      </template>
    </b-modal>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  metaInfo: {
    title: 'Sistemas externos',
    titleTemplate: null,
  },

  components: {
    Menu,
    Footer,
    SectionTitle,
  },

  data() {
    return {
      loading: false,
      salvandoModal: false,
      alteracaoConfirmada: false,
      possuiParceiro: false,
      integracaoSelecionada: null,
      uuid: null,
      integracoes: [
        {
          tipo: 'saude_responde',
          nome: 'Saúde Responde',
          descricao:
            'Chave de assinatura gerada em Sistemas externos para acesso no Atendimento.',
          configurada: false,
          editando: false,
          novaChave: '',
          exibirChave: false,
          salvando: false,
        },
        {
          tipo: 'menu_lateral',
          nome: 'Menu Lateral',
          descricao:
            'Chave de assinatura gerada em Sistemas externos para acesso no Menu Lateral.',
          configurada: false,
          editando: false,
          novaChave: '',
          exibirChave: false,
          salvando: false,
        },
      ],
    }
  },
  computed: {
    /**
     * Informa se o usuário pode confirmar o salvamento da chave.
     *
     * No primeiro cadastro, não é necessária confirmação adicional.
     * Na substituição, o usuário precisa marcar que está ciente da
     * inativação da integração atual.
     *
     * @returns {boolean}
     */
    podeConfirmarSalvamento() {
      if (this.salvandoModal || !this.integracaoSelecionada) {
        return false
      }

      if (!this.integracaoSelecionada.configurada) {
        return true
      }

      return this.alteracaoConfirmada
    },
  },
  mounted() {
    this.buscarConfiguracoes()
  },
  methods: {
    /**
     * Busca o estado das chaves e garante a existência do UUID público.
     *
     * @returns {Promise<void>}
     */
    async buscarConfiguracoes() {
      this.loading = true

      try {
        const { data } = await this.$api.get(
          `/app/sistemas-externos/${this.$store.state.cod_ibge}/chaves-assinatura`
        )

        this.possuiParceiro = Boolean(data.parceiro)
        this.uuid = data.integracoes?.uuid || null

        this.integracoes.forEach((integracao) => {
          const configuracao = data.integracoes?.[integracao.tipo]

          integracao.configurada = Boolean(configuracao?.configurada)
        })

        if (!this.uuid) {
          await this.gerarIdentificadorPublico()
        }
      } catch (error) {
        this.$toast.error(
          'Não foi possível carregar as configurações das integrações.'
        )
      } finally {
        this.loading = false
      }
    },

    /**
     * Gera o UUID público utilizado nas URLs das integrações.
     *
     * Caso já exista um identificador, a API retorna o UUID atual.
     *
     * @returns {Promise<void>}
     */
    async gerarIdentificadorPublico() {
      const { data } = await this.$api.put(
        `/app/sistemas-externos/${this.$store.state.cod_ibge}/identificador-publico`
      )

      this.uuid = data.uuid || null

      if (!this.uuid) {
        throw new Error(
          'A API não retornou o identificador público da integração.'
        )
      }
    },

    /**
     * Monta a URL pública correspondente ao tipo de integração.
     *
     * O UUID é compartilhado entre as integrações do município.
     *
     * @param {Object} integracao Integração que terá a URL montada.
     * @param {string} integracao.tipo Identificador do tipo de integração.
     * @returns {string}
     */
    obterUrlIntegracao(integracao) {
      if (!this.uuid) {
        return ''
      }

      const dominio = this.obterDominioIntegracao()

      if (integracao.tipo === 'saude_responde') {
        return (
          `${dominio}/pep/${this.uuid}` +
          '?documentoProfissional=[documentoProfissional]' +
          '&documentoCidadao=[documentoCidadao]' +
          '&CNES=[CNES]'
        )
      }

      if (integracao.tipo === 'menu_lateral') {
        return (
          `${dominio}/login/${this.uuid}` +
          '?documentoProfissional=[documentoProfissional]' +
          '&CNES=[CNES]'
        )
      }

      return ''
    },

    /**
     * Retorna o domínio utilizado nas URLs das integrações.
     *
     * Municípios vinculados a parceiro utilizam o domínio Meu SUS.
     * Os demais utilizam o domínio oficial do eSUS Feedback.
     *
     * @returns {string}
     */
    obterDominioIntegracao() {
      return this.possuiParceiro
        ? 'https://measus.com.br'
        : 'https://esusfeedback.com.br'
    },

    /**
     * Copia a URL da integração para a área de transferência.
     *
     * Utiliza a API Clipboard quando disponível. Em navegadores sem suporte,
     * realiza a cópia por meio de um campo de texto temporário.
     *
     * @param {Object} integracao Integração cuja URL será copiada.
     * @returns {Promise<void>}
     */
    async copiarUrl(integracao) {
      const url = this.obterUrlIntegracao(integracao)

      if (!url) {
        this.$toast.error('A URL da integração não está disponível.')
        return
      }

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url)
        } else {
          this.copiarTextoComFallback(url)
        }

        this.$toast.success('URL copiada com sucesso.')
      } catch (error) {
        this.$toast.error('Não foi possível copiar a URL.')
      }
    },

    /**
     * Copia uma informação do sistema para a área de transferência.
     *
     * @param {string} texto Conteúdo que será copiado.
     * @param {string} campo Nome do campo copiado.
     * @returns {Promise<void>}
     */
    async copiarInformacao(texto, campo) {
      if (!texto) {
        return
      }

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(texto)
        } else {
          this.copiarTextoComFallback(texto)
        }

        this.$toast.success(`${campo} copiado com sucesso.`)
      } catch (error) {
        this.$toast.error(`Não foi possível copiar o campo ${campo}.`)
      }
    },

    /**
     * Copia um texto utilizando um elemento temporário.
     *
     * Este método funciona como alternativa para navegadores que não oferecem
     * suporte à API Clipboard ou quando a aplicação não está em contexto seguro.
     *
     * @param {string} texto Texto que será copiado.
     * @returns {void}
     */
    copiarTextoComFallback(texto) {
      const campoTemporario = document.createElement('textarea')

      campoTemporario.value = texto
      campoTemporario.setAttribute('readonly', '')
      campoTemporario.style.position = 'fixed'
      campoTemporario.style.opacity = '0'

      document.body.appendChild(campoTemporario)

      campoTemporario.select()
      document.execCommand('copy')

      document.body.removeChild(campoTemporario)
    },

    /**
     * Limpa os dados temporários utilizados pelo modal de confirmação.
     *
     * @returns {void}
     */
    limparModalConfirmacao() {
      this.integracaoSelecionada = null
      this.alteracaoConfirmada = false
      this.salvandoModal = false
    },

    /**
     * Habilita o formulário para substituição de uma chave configurada.
     *
     * O UUID atual é preservado, pois a alteração da chave não deve gerar
     * um novo identificador público.
     *
     * @param {Object} integracao Integração que terá a chave alterada.
     * @returns {void}
     */
    iniciarAlteracao(integracao) {
      integracao.editando = true
      integracao.novaChave = ''
      integracao.exibirChave = false
    },

    /**
     * Cancela a alteração da chave de assinatura.
     *
     * Restaura a visualização normal da integração e remove o valor digitado.
     *
     * @param {Object} integracao Integração cuja alteração será cancelada.
     * @returns {void}
     */
    cancelarAlteracao(integracao) {
      integracao.editando = false
      integracao.novaChave = ''
      integracao.exibirChave = false
    },

    /**
     * Abre o modal de confirmação antes do salvamento da chave.
     *
     * O modal somente é exibido quando uma nova chave foi informada.
     *
     * @param {Object} integracao Integração que receberá a chave.
     * @returns {void}
     */
    confirmarSalvamento(integracao) {
      if (!this.uuid || !integracao.novaChave) {
        return
      }

      integracao.novaChave = this.normalizarChaveAssinatura(
        integracao.novaChave
      )

      if (!integracao.novaChave) {
        this.$toast.error('Informe uma chave de assinatura válida.')
        return
      }

      this.alteracaoConfirmada = false
      this.integracaoSelecionada = integracao
      this.$refs.modalConfirmarChave.show()
    },

    /**
     * Cadastra ou substitui a chave da integração selecionada.
     *
     * O UUID público já deve ter sido gerado durante o carregamento das
     * configurações. O salvamento da chave não altera o identificador atual.
     *
     * @returns {Promise<void>}
     */
    async salvarChave() {
      const integracao = this.integracaoSelecionada

      if (
        !this.uuid ||
        !integracao ||
        integracao.salvando ||
        (integracao.configurada && !this.alteracaoConfirmada)
      ) {
        return
      }

      this.salvandoModal = true
      integracao.salvando = true

      try {
        await this.$api.put(
          `/app/sistemas-externos/${this.$store.state.cod_ibge}/chaves-assinatura/${integracao.tipo}`,
          {
            chave_assinatura: integracao.novaChave,
          }
        )
        integracao.configurada = true
        integracao.editando = false
        integracao.novaChave = ''
        integracao.exibirChave = false

        this.$refs.modalConfirmarChave.hide()

        this.$toast.success(
          `Chave de assinatura de ${integracao.nome} salva com sucesso.`
        )
      } catch (error) {
        this.$toast.error(
          `Não foi possível salvar a chave de assinatura de ${integracao.nome}.`
        )
      } finally {
        this.salvandoModal = false
        integracao.salvando = false
      }
    },

    /**
     * Normaliza a chave de assinatura informada pelo usuário.
     *
     * Remove o prefixo "Chave de assinatura:" quando ele for
     * informado juntamente com a chave.
     *
     * @param {string} chave Chave de assinatura informada.
     * @returns {string}
     */
    normalizarChaveAssinatura(chave) {
      return String(chave || '')
        .replace(/^chave\s+de\s+assinatura\s*:\s*/i, '')
        .trim()
    },
  },
}
</script>

<style lang="scss" scoped>
.chaves-alerta {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;

  > i {
    margin-top: 3px;
    font-size: 22px;
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 60px 0;
}

.integracao-card {
  height: 100%;
  padding: 24px;
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(30, 42, 56, 0.06);

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #edf0f2;

    h3 {
      margin: 0 0 6px;
      font-size: 20px;
      font-weight: 600;
    }

    p {
      margin: 0;
      color: #68737d;
      font-size: 14px;
    }
  }

  &__acoes {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 24px;
  }
}

.integracao-status {
  flex-shrink: 0;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;

  &--configurada {
    color: #287a45;
    background-color: #e5f5eb;
  }

  &--pendente {
    color: #946200;
    background-color: #fff3cd;
  }
}

.chave-configurada {
  &__status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  &__conteudo {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    gap: 12px;

    > i {
      flex-shrink: 0;
      color: #287a45;
      font-size: 28px;
    }

    > div {
      min-width: 0;
    }

    p {
      color: #68737d;
      font-size: 14px;
    }
  }

  &__status > .btn {
    flex-shrink: 0;
    white-space: nowrap;
  }
}

.integracao-informacoes {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #edf0f2;

  &__item {
    display: grid;
    grid-template-columns: minmax(130px, 160px) minmax(0, 1fr);
    align-items: center;
    gap: 16px;
    padding: 10px 0;
    border-bottom: 1px solid #f1f3f5;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: 0;
    }
  }

  &__label {
    color: #68737d;
    font-size: 13px;
    font-weight: 600;
  }

  &__valor {
    display: flex;
    align-items: center;
    min-width: 0;
    gap: 8px;
    color: #2f3a44;
    font-size: 14px;
    overflow-wrap: anywhere;
  }

  &__copiar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 27px;
    height: 25px;
    padding: 0;
    background-color: #000;
    border-color: #000;
    font-size: 11px;
  }
}

@media (max-width: 767px) {
  .integracao-card {
    &__header {
      flex-direction: column;
    }
  }

  .integracao-informacoes {
    &__item {
      grid-template-columns: 1fr;
      gap: 4px;
    }
  }

  .integracao-url {
    &__header {
      align-items: center;
    }
  }

  .integracao-status {
    align-self: flex-start;
  }

  .chave-configurada {
    &__status {
      align-items: stretch;
      flex-direction: column;

      > .btn {
        width: 100%;
      }
    }
  }
}
</style>
